import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { VisitCompletionRule } from "@app/models/rest/visit-completion-rule";

@Injectable({
  providedIn: "root"
})
export class VisitCompletionRuleRestService extends HateoasResourceOperation<VisitCompletionRule> {
  constructor() {
    super(VisitCompletionRule);
  }
}
